import { AddMemberPopupComponent } from './add-member-popup.component';
import { DialogService } from './../../../../shared/services/dialog.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../../../shared/services/base.service';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../../../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { Utility } from '../../../../common/utility';
import { ValidationService } from '../../../../shared/services/validation.service';
import * as moment from 'moment';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { ListMemberService } from '../list-member.service';
import { Appointment } from '../../../../models/request-appointment/appointment.model';

@Component({
  selector: 'small-group',
  templateUrl: 'small-group.component.html',
  providers: [ListMemberService]
})
export class SmallGroupComponent implements OnInit, AfterViewInit {
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger: Subject<any> = new Subject();

  public appConstants = AppConstants;
  public dataMembers = [];
  public bookingMemberModel = new Appointment();

  public centreId: string;
  constructor(
    private activeRouter: ActivatedRoute,
    public utility: Utility,
    private formBuilder: FormBuilder,
    public dialogService: DialogService,
    private router: Router,
    public listMemberService: ListMemberService) { }

  ngOnInit() {
    this.centreId = this.activeRouter.snapshot.params['id'] || null;

    this.listMemberService.getBookingCache(this.centreId).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data !== null && data !== undefined) {
            this.bookingMemberModel = data;
            if (this.bookingMemberModel.listMembers.length) {
              // this.dataMembers = this.bookingMemberModel.listMembers;
              // this.bookingMemberModel.listMembers.forEach(element => {
              //   this.dataMembers.push(element);
              // });
              // update table
              this.rerender();
              console.log('listMembers', this.bookingMemberModel.listMembers);
            }
          }
        }
      }
    );

    this.dtOptions = {
      pagingType: 'full_numbers',
      paging: false,
      searching: false,
      retrieve: true,
      lengthChange: false,
      data: this.dataMembers,
      columns: [{
        title: 'Name',
        data: 'name'
      }, {
        title: 'DOB',
        data: 'dateOfBirth',
        render: function (data, type, row) {
          return moment(data.toString()).format('DD MMM YYYY');
        }
      }, {
        title: 'Country Of Birth',
        data: 'countryOfBirth'
      }, {
        title: 'Address',
        data: 'address'
      }, {
        title: 'Mobile Phone',
        data: 'phone'
      }, {
        title: 'Country',
        data: 'country',
      }, {
        title: 'Email',
        data: 'email',
      }, {
        title: 'Occupation',
        data: 'occupation',
      },
      {
        title: 'Action',
        data: 'email',
        render: function (data, type, row) {
          // let temp = self.dataMembers.length == 2 ? 'disabled' : '';
          return `<a class="action" attr-id ="${data}" title="Remove">Remove</a>`;
        }
      },

      ],

      language: {
        emptyTable: 'No member record',
        info: 'Total _TOTAL_ member(s)',
        infoEmpty: 'Total 0 member(s)',
        processing: '<img src="../assets/images/spinner.gif" />'
      }
    };


  }

  ngAfterViewInit() {
    this.dtTrigger.next();
    const self = this;
    $(function () {
      $('#small_group').on('click', '.action', function () {
        const email = $(this).attr('attr-id');
        self.onRemove(email);
      });
    });
  }

  onViewCalendar() {
    // if there are some duplicated records (same First Name, Surname and DOB), display error message
    if (this.listMemberService.isDuplicatePatientInList(this.dataMembers) === true) {
      this.dialogService.openErrorDialog({ message: AppMessages.booking.duplicateRecord });
      return;
    }
    this.bookingMemberModel.listMembers = this.dataMembers;
    if (this.dataMembers.length >= 2) {
      this.listMemberService.addBookingCache(this.bookingMemberModel).subscribe(
        result => {
          if (result) {
            this.router.navigate(['view-schedule', this.centreId]);
          }
        }
      );
    } else {
      this.dialogService.openErrorDialog({ message: AppMessages.requestForAppointment.errorMemberSmallGroup });
    }
  }

  onAddMember() {
    if (this.dataMembers.length < 9) {
      const data = {
        list: this.dataMembers
      };
      this.dialogService.openComponentDialog(AddMemberPopupComponent, data).subscribe(
        members => {
          if (members.length) {
            members.forEach(element => {
              element.phone = element.mobilePhone;
              this.dataMembers.push(element);
            });
            // update table
            this.rerender();
          }
        }
      );
    } else {
      this.dialogService.openErrorDialog({ message: AppMessages.requestForAppointment.errorAddMember });
    }

  }

  onBack() {
    this.bookingMemberModel.listMembers = this.dataMembers;
    this.listMemberService.addBookingCache(this.bookingMemberModel).subscribe(
      result => {
        if (result) {
          this.router.navigate(['/request-appointment', this.centreId]);
        }
      }
    );

  }

  onRemove(email) {
    const index = this.dataMembers.findIndex(item => item.email === email);
    this.dataMembers.splice(index, 1);
    this.rerender();
  }

  /**
   * for Rerender table
   */
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/list-member/small-group/small-group.component.ts